import React, { useRef, useContext, useState } from 'react';
import { Context as AuthContext } from 'contexts/auth';
import { Context as CompanyContext } from 'contexts/company';
import { Config } from 'configs';
import { useAggregate } from 'hooks';
import { DropDownList } from 'components/formInputs/dropDownList';
import { TemplateVariationForm } from 'views/variation-templates/_form_template_variation';
import { FormDialog } from 'components/dialogs/formDialog';
import { Link } from 'react-router-dom';

export const ProductVariationTemplatesAddEditForm = ({
  productId,
  itemData,
  isOpen,
  closeModal,
  onSaved,
  isSynced,
  allProducts,
}) => {
  const isEdit = itemData != null;
  const cancelButtonRef = useRef(null);
  const { state: auth } = useContext(AuthContext);
  const { getById } = useContext(CompanyContext);
  const [variationData, setVariationData] = useState(itemData || null);
  const formRef = useRef(null);

  // const variationTemplatesRequestData = {
  //   secretKey: auth.token,
  //   collectionName: Config.DATA.COLLECTIONS.VARIATION_TEMPLATES,
  //   filter: `{ "company": ObjectId("${auth.company?.company}") }`,
  //   cultureCode: Config.DEFAULTS.LANGUAGE,
  // };

  // const [, variationTemplates] = useFind(variationTemplatesRequestData);

  const variationTemplatesRequestData = {
    collectionName: Config.DATA.COLLECTIONS.VARIATION_TEMPLATES,
    aggregateId: Config.DATA.AGGREGATES.GET_ALL_VARIATION_TEMPLATES,
    secretKey: auth.token,
    filter: { company: auth.company?.company },
    loadOnInit: true,
    companyIdForV2: auth.company?.company,
    aggregateIdV2: 'AdminGetVariationTemplatesOptions',
  };

  const [, variationTemplates] = useAggregate(variationTemplatesRequestData);

  const onVariationTemplateChange = async (e) => {
    const getTemplateByIdRequestData = {
      token: auth.token,
      collectionName: Config.DATA.COLLECTIONS.VARIATION_TEMPLATES,
      id: e.target.value,
      excludeCulture: true,
      resourceV2: 'AdminVariationTemplate',
      companyIdForV2: auth.company?.company,
    };

    if (e.target.value === '-1') {
      setVariationData(null);
    } else {
      const templateDataResponse = await getById(getTemplateByIdRequestData);

      if (templateDataResponse) {
        setVariationData(templateDataResponse);
      }
    }
  };

  const onSubmitClicked = () => {
    formRef.current.click();
  };

  const renderVariationTemplates = () => {
    const vtSelectionOptions = [
      {
        label: 'Not Set',
        value: -1,
      },
    ];

    if (variationTemplates) {
      variationTemplates.forEach((vt) => {
        vtSelectionOptions.push({
          label: vt.template_name,
          value: vt._id,
        });
      });
    }

    return vtSelectionOptions;
  };

  return (
    <FormDialog
      isOpen={isOpen}
      cancelButtonRef={cancelButtonRef}
      onClose={closeModal}
      title={itemData ? 'Edit' : 'Add New'}
      buttons={[
        { text: 'Save', onClick: onSubmitClicked, color: 'blue' },
        { text: 'Close', onClick: closeModal, color: 'gray' },
      ]}
    >
      <div>
        <TemplateVariationForm
          itemData={variationData}
          isEdit={isEdit}
          ref={formRef}
          isProductVariation
          productId={productId}
          navigateAfterSubmitCallback={() => {
            if (onSaved) {
              onSaved();
              closeModal();
            }
          }}
          isSynced={isSynced}
          allProducts={allProducts}
          isAttachedOnEdit={isEdit && itemData && itemData.template}
        >
          {!isSynced && (!isEdit || (isEdit && itemData && itemData.template)) && (
            <>
              <div className="col-span-6 sm:col-span-3 text-left">
                <DropDownList
                  showLabel
                  id="variation_template"
                  name="variation_template"
                  label="Variation template"
                  options={renderVariationTemplates()}
                  className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                  onChange={(e) => onVariationTemplateChange(e)}
                  value={isEdit && itemData && itemData.template ? itemData.template : undefined}
                  disabled={isEdit}
                />
                {isEdit && itemData && itemData.template && (
                <Link to={`/settings/variation-templates/${itemData.template}`} className="text-sm font-normal text-indigo-600 hover:text-indigo-900">
                  Edit template options
                </Link>
                )}
              </div>
              <div className="hidden sm:block sm:col-span-3 " />
            </>
          )}
        </TemplateVariationForm>
      </div>
    </FormDialog>
  );
};
